<script>
import { Bar } from "vue-chartjs";
import {mapActions, mapGetters} from "vuex";

export default {
  extends: Bar,
  computed:{
    ...mapGetters(['saleManagerAmount','saleManagerListDay'])
  },
   async mounted() {
    await this.fetchSquarePayments()
    await this.renderChart(
        {
          labels: this.saleManagerListDay,
          datasets: [
            {
              label: "売上（万円)",
              backgroundColor: "rgb(86 188 218)",
              hoverBackgroundColor: "rgb(86 188 218)",
              data: this.saleManagerAmount
            }
          ],
        },
        {
          legend: {
            position: 'top'
          },
          responsive: true,
          maintainAspectRatio: false
        }
    );
  },
  methods:{
    ...mapActions('sale_manager', ['fetchSquarePayments'])
  }
};
</script>
